import type { FC, ReactNode } from 'react'
import type { SupportArticle } from '@/data/support'

import Link from 'next/link'

import { routes } from '@/lib/routes'

type SupportNavProps = {
    articles: SupportArticle[]
    activeSlug?: string
    showSearch?: boolean
    id?: string
}

export const SupportNav: FC<SupportNavProps> = ({ articles, activeSlug, showSearch = false, id }): ReactNode => {
    return (
        <div id={id} className='support-navigation-holder'>
            {showSearch && (
                <div className='support-nav'>
                    <form action={routes.search} method='get' className='search-form w-form'>
                        <input
                            className='search-input w-input'
                            maxLength={256}
                            name='query'
                            placeholder='Search…'
                            type='search'
                            aria-label='Search support'
                            required
                        />
                        <input type='submit' className='search-button w-button' value='' />
                    </form>
                </div>
            )}
            <div className='support-navigation-cards'>
                <div className='collection-list-wrapper'>
                    <div role='list' className='w-dyn-items'>
                        {articles.map(article => (
                            <div key={article.slug} role='listitem' className='w-dyn-item'>
                                <Link
                                    href={routes.supportArticle(article.slug)}
                                    className={`list-item-card w-inline-block${article.slug === activeSlug ? ' w--current' : ''}`}
                                >
                                    <div className='list-item-text'>{article.name}</div>
                                </Link>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}
